<details>
  <summary i18n>Columns</summary>
  <div class="options">
    @for (column of colDefs(); track column.field) {
      <label>
        <input type="checkbox" [checked]="!column.hide" (change)="toggleColumn(column.field, $event)" />
        {{ column.headerName }}
      </label>
    }
  </div>
</details>
